import React from 'react';

const AuthDivider = () => {
  return (
    <div className="relative my-6 md:my-8">
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-border" />
      </div>
      <div className="relative flex justify-center text-xs md:text-sm uppercase">
        <span className="bg-background px-4 text-muted-foreground font-medium">
          Or continue with
        </span>
      </div>
    </div>
  );
};

export default AuthDivider;